tippy('[data-tippy-content]');

jQuery(window).on('cc-variant-updated', function (event, data){
    let dynamic_add_button = jQuery('form.product-purchase-form [type="submit"]');
    let klaviyoStockButton = jQuery('form.product-purchase-form button[data-klaviyo-form-id]');
    klaviyoStockButton.hide();
    dynamic_add_button.show();
    if(!data.variant.available && !data.hasComponents) {
        let outOfStockButton = jQuery('#BIS_trigger.whole-product-unavailable');
        if (outOfStockButton.length) {
            outOfStockButton.attr('data-variant-id', data.variant.id);
        }
        /* If product is unavailable and has no components, display app back in stock trigger */
        else {
            dynamic_add_button.attr('data-variant-id', data.variant.id);
            dynamic_add_button.attr('id', "BIS_trigger");
            dynamic_add_button.removeAttr('disabled');
            dynamic_add_button.html(dynamic_add_button.html()+` - ${theme.strings.products_subscribe_stock_alert} <i class='lni lni-envelope'></i>`);
        }
    }
    /* If product is composite but components are unavailable AND a Klaviyo form has been attached, allow to trigger the form */
    else if(data.variant.available && data.hasComponents && !data.componentsAvailable && klaviyoStockButton.length){
        dynamic_add_button.hide();
        klaviyoStockButton.show();
    }
    else{
        jQuery('form.product-purchase-form [type="submit"]').attr('id', '');
    }
});

jQuery(window).on('cc-variant-before-update', function (event, data) {
    let preorderDate = jQuery(`.preorder-date-info[data-variant-id="${data.variant.id}"]`).text()
            || jQuery(`.preorder-date-info[data-product-id="${data.product.id}"]`).text();

    let preorderTooltip = jQuery('.price-label--preorder');
    if(preorderDate) {
        if(moment(preorderDate, 'DD/MM/YYYY') >= moment().add(44, 'days')) {
            jQuery('[data-add-to-cart-text]').data('add-to-cart-text', theme.strings.products_product_preorder);
        }
        else {
            jQuery('[data-add-to-cart-text]').data('add-to-cart-text',theme.strings.products_product_add_to_cart);
        }
        preorderTooltip.find('.dynamic-date').text(preorderDate);
        preorderTooltip.fadeIn();
    }
    else {
        jQuery('[data-add-to-cart-text]').data('add-to-cart-text', theme.strings.products_product_add_to_cart);
        preorderTooltip.hide();
    }
});

(() => {
    let expressCheckoutFired = false;
    window.addEventListener("blur", () => {
        if (expressCheckoutFired)
            return;

        setTimeout(() => {
            let elem = document.activeElement
            if (elem.tagName === "IFRAME" && (/paypal/i).test(elem.outerHTML)) {
                expressCheckoutFired = true
                gtag('event', 'express_checkout_clicked_on_product', {
                    'button': 'Paypal'
                });
            }
        });
    });

    jQuery('.accelerated-checkout-btn-wrapper').on('click', (event) => {
        if (expressCheckoutFired)
            return

        const $elem = jQuery(event.currentTarget).find('.shopify-payment-button__button')
        if ((/apple/i).test($elem.prop('outerHTML')))
            gtag('event', 'express_checkout_clicked_on_product', {
                'button': 'Apple Pay'
            });
        else
            gtag('event', 'express_checkout_clicked_on_product', {
                'button': 'Standard Buy Now'
            });

        expressCheckoutFired = true
    })
})();

const getCurrentProductData = (() => {
    let productData = null;

    return () => {
        if (productData)
            return productData

        const pId = jQuery('form.shopify-product-form input[name="product-id"]').val();
        productData = JSON.parse(document.getElementById('ProductJson-' + pId).innerHTML);

        return productData
    }
})();

const MML_VideoAnalytics = (() => {
    let videoPlayed = false;
    let hasReached50Percent = false;

    const productData = getCurrentProductData();

    const videoCheckLoop = setInterval(() => {
        if (jQuery('.product-detail .gallery .thumbnails .thumbnail--media-video').length) {
            gtag('event', 'product_view_with_video', {
                'product_name': productData.title,
                'product_id': productData.id
            });
            clearInterval(videoCheckLoop);
        }
    }, 1000);

    const onTimeUpdated = (event) => {
        if (event.target.currentTime / event.target.duration * 100 > 50 && !hasReached50Percent) {
            gtag('event', 'product_video_viewed_50%', {
                'product_name': productData.title,
                'product_id': productData.id
            });
            hasReached50Percent = true;
        }

        if (hasReached50Percent && event.target.currentTime < 1) {
            gtag('event', 'product_video_viewed_full', {
                'product_name': productData.title,
                'product_id': productData.id
            });
            event.target.removeEventListener('timeupdate', onTimeUpdated)
        }
    }

    return {
        onPlay: (event) => {
            if(videoPlayed)
                return;
            videoPlayed = true;
            gtag('event', 'product_video_played', {
                'product_name': productData.title,
                'product_id': productData.id
            });
            event.target.addEventListener('timeupdate', onTimeUpdated)
        }
    }
})();